import React from "react";
import { FiDownload, FiTrash2 } from "react-icons/fi";
import { card, saveBlob, slug } from "../VideoStudioPanel";
import { clockText, sizeText } from "../../video/upscale/plan";

const fileName = (item, suffix) => `${slug(item.name.replace(/\.[^.]+$/, ""))}-${suffix}.${item.ext}`;

// The finished videos of a page: a player, what was done, and Save / Remove. `suffix(item)` names the saved file.
export default function ResultsList({ results, onRemove, suffix }) {
  if (!results.length) return null;
  return (
    <div className="mt-10 space-y-6" data-testid="video-results">
      <p className="text-xs uppercase tracking-widest text-white/50 font-semibold">Your finished videos <span className="normal-case tracking-normal text-gray-500 font-normal">- kept until you leave this page, so save them</span></p>
      {results.map((item) => (
        <div key={item.id} className={`${card} grid md:grid-cols-[1.4fr_1fr] gap-6 items-start`}>
          <video src={item.url} controls playsInline preload="metadata" className="w-full max-h-[420px] rounded-xl bg-black" />
          <div className="space-y-3">
            <p className="font-semibold break-words" dir="auto">{item.name}</p>
            <p className="text-sm text-gray-300">
              {item.inW === item.w && item.inH === item.h ? <strong>{item.w}×{item.h}</strong> : <><strong>{item.inW}×{item.inH}</strong> → <strong className="text-accent-light">{item.w}×{item.h}</strong></>} · {item.look} · {clockText(item.seconds)}
            </p>
            {item.extra && <p className="text-xs text-gray-400">{item.extra}</p>}
            <p className="text-xs text-gray-500">{sizeText(item.size)} · made in {clockText(item.took)}</p>
            {item.notes.map((n) => <p key={n} className="text-xs text-amber-200 bg-amber-500/10 border border-amber-500/30 rounded-lg px-3 py-2">{n}</p>)}
            <div className="flex flex-wrap gap-3 pt-1">
              <button type="button" onClick={() => saveBlob(fileName(item, suffix(item)), item.blob)} className="px-5 py-3 rounded-full bg-brand-gradient text-white text-sm font-semibold inline-flex items-center gap-2"><FiDownload /> Save the video</button>
              <button type="button" onClick={() => onRemove(item)} className="px-4 py-3 rounded-full border border-white/20 hover:border-red-400 text-sm inline-flex items-center gap-2"><FiTrash2 size={14} /> Remove</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
